import { PRICING_WHATSAPP_URL, PHONE_DISPLAY, PHONE_E164 } from '../../config/contact';
import './PricingSection.css';

const POINTS = [
  'A plan shaped around your channels and message volume',
  'No setup fees, no contracts, cancel anytime',
  'Straight answer on WhatsApp, usually within minutes',
];

export default function PricingSection() {
  return (
    <section className="pricing section" id="pricing">
      <div className="container">
        <div className="pricing__panel">
          <div className="pricing__glow" aria-hidden="true" />

          <div className="pricing__body">
            <span className="badge badge-brand">Pricing</span>
            <h2 className="display-lg pricing__title">
              Every business is different.<br />
              <span className="gradient-text">So is every quote.</span>
            </h2>
            <p className="text-lg pricing__sub">
              Tell us your channels and how many conversations you handle each month,
              and we'll send you a price that fits. One WhatsApp message is all it takes.
            </p>

            <ul className="pricing__points">
              {POINTS.map(p => (
                <li key={p} className="pricing__point">
                  <svg width="18" height="18" viewBox="0 0 20 20" fill="none" className="pricing__point-check" aria-hidden="true">
                    <circle cx="10" cy="10" r="10" fill="rgba(99,102,241,0.12)" />
                    <path d="M6 10l3 3 5-5" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  {p}
                </li>
              ))}
            </ul>

            <div className="pricing__actions">
              <a
                href={PRICING_WHATSAPP_URL}
                className="btn btn-primary btn-lg pricing__cta"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                Get pricing on WhatsApp
              </a>
              <a href={`tel:${PHONE_E164}`} className="btn btn-secondary btn-lg pricing__call">
                {PHONE_DISPLAY}
              </a>
            </div>

            <p className="pricing__note">
              Prefer email? Write to <a href="mailto:support@zepliq.com" className="pricing__note-link">support@zepliq.com</a> and we'll reply within 24 hours.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
